export const classes = {
  account: 'text-xs text-taupe-2 hover:underline dark:text-mauve-2',
};
